module.exports = __webpack_public_path__ + "static/dimaduchet_2-2ba4c4772d0bbc8a52f2a49c79e27d93.png";